import React, { FunctionComponent } from 'react';
import { FieldProps } from 'formik';
import { RadioProps, Radio } from '@inplayer-org/inplayer-ui';

export type RadioFieldProps = FieldProps & RadioProps;

const RadioField: FunctionComponent<RadioFieldProps> = ({ field, checked, ...rest }) => (
  <Radio checked={checked ?? field.value === rest.value} {...field} {...rest} />
);

export default RadioField;
